import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Stories from './pages/Stories';
import Layout from './components/Layout';
import './styles/main.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/stories" element={<Stories />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;